import { ArrowRight, Play } from "lucide-react";

const Hero = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  // Staggered Ladeanimation — fill-mode "both" verhindert Flackern trotz Delay
  const reveal = (delay) => ({ animationDelay: delay, animationFillMode: "both" });

  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden grain" data-testid="hero-section">
      {/* Video-Hintergrund (unverändert: dein Showreel) */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/thumbnails/hero-poster.webp"
          className="w-full h-full object-cover"
        >
          <source src="https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/showreel-v2.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Cinematische Overlays — ÜBER dem Video, damit der Text lesbar wird.
          Links dunkel (Textzone), rechts frei (Video bleibt sichtbar). */}
      <div className="absolute inset-0 z-[1] bg-gradient-to-r from-background via-background/60 to-transparent" />
      <div className="absolute inset-0 z-[1] bg-gradient-to-t from-background via-transparent to-background/30" />

      {/* Inhalt */}
      <div className="relative z-10 min-h-[100svh] flex items-center pt-20 pb-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            {/* Eyebrow */}
            <div
              className="animate-fade-in-up inline-flex items-center gap-2.5 mb-6 px-3.5 py-1.5 rounded-full border border-[hsl(var(--accent))]/30 bg-[hsl(var(--accent))]/10 backdrop-blur-sm"
              style={reveal("0s")}
            >
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--accent))] opacity-75 animate-ping" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[hsl(var(--accent))]" />
              </span>
              <span className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-[hsl(var(--accent))]">
                Filmemacher & KI-Plattform · Villingen-Schwenningen
              </span>
            </div>

            {/* Headline — kurz, wuchtig */}
            <h1
              className="animate-fade-in-up text-5xl sm:text-6xl lg:text-8xl font-bold mb-6 leading-[1.02] tracking-[-0.02em] text-white drop-shadow-2xl"
              style={reveal("0.1s")}
              data-testid="hero-headline"
            >
              Videoproduktion aus dem{" "}
              <span className="neon-text text-[hsl(var(--accent))]">Schwarzwald</span>.
            </h1>

            {/* Subline — kompakt, trägt die Keywords */}
            <p
              className="animate-fade-in-up text-base sm:text-xl text-white/75 mb-9 max-w-xl leading-relaxed"
              style={reveal("0.2s")}
              data-testid="hero-subline"
            >
              Reels, Imagefilme &amp; Kampagnen — vor Ort im Schwarzwald.
              KI-Content und Websites deutschlandweit remote.
            </p>

            {/* CTAs */}
            <div
              className="animate-fade-in-up flex flex-col sm:flex-row gap-3 sm:gap-4"
              style={reveal("0.3s")}
            >
              <button
                onClick={() => scrollToSection("cases")}
                className="group px-7 py-3.5 sm:px-8 sm:py-4 bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/90 text-white rounded-2xl font-semibold transition-all duration-300 flex items-center justify-center gap-2.5 neon-glow hover:scale-[1.03]"
                data-testid="portfolio-cta"
              >
                <Play className="w-5 h-5" fill="currentColor" />
                Portfolio ansehen
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="group px-7 py-3.5 sm:px-8 sm:py-4 bg-white/5 hover:bg-white/10 backdrop-blur-md border border-white/15 text-white rounded-2xl font-semibold transition-all duration-300 flex items-center justify-center gap-2.5 hover:scale-[1.03]"
                data-testid="project-cta"
              >
                Projekt anfragen
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>

            {/* Trust-Zeile — subtiler Beleg */}
            <div
              className="animate-fade-in-up mt-10 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs sm:text-sm text-white/50"
              style={reveal("0.4s")}
            >
              <span><span className="text-white/90 font-semibold">70+</span> Kunden</span>
              <span className="w-1 h-1 rounded-full bg-white/30" />
              <span><span className="text-white/90 font-semibold">200+</span> Videos</span>
              <span className="w-1 h-1 rounded-full bg-white/30" />
              <span><span className="text-white/90 font-semibold">5</span> Jahre</span>
              <span className="w-1 h-1 rounded-full bg-white/30" />
              <span><span className="text-white/90 font-semibold">Eigene</span> KI-Plattform</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll-Indikator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/25 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-2 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
